import React, { useEffect, useState, useRef, createRef } from "react";
import * as CS from "../../../../styles/CourseViewStyled";
import * as QS from "../../../../styles/QuizStyled";
import darkTitleBottom from "../../../../assets/images/darkTitleBottom.png";
import lightTitleBottom from "../../../../assets/images/lightTitleBottom.png";
import darkTitleTop from "../../../../assets/images/darkTitleTop.png";
import lightTitleTop from "../../../../assets/images/lightTitleTop.png";
import greenCheck from "../../../../assets/images/greenCheck.png";
import greyClock from "../../../../assets/images/greyClock.png";
import rewardIcon from "../../../../assets/images/rewardIcon.png";
import * as SS from "../../../../styles/SectionStyled";
import bannerImage from "../../../../assets/images/bannerImage.jpeg";
import rewardsWatch from "../../../../assets/images/rewardsWatch.png";
import MoreLessEpisode from "../../../../components/MoreLessEpisode";
import { Course, NextTab } from "../../../../utils/api";
import rewardLightsUnWatch from "../../../../assets/images/rewardLightsUnWatch.png";
import rewardLight from "../../../../assets/images/rewardLight.png";
import episodePlay from "../../../../assets/images/episodePlay.png";
import * as FS from "../../../../styles/FormStyled";
import playBoto from "../../../../assets/images/playBoto.png";
import axios from "../../../../utils/axios";
import { get } from "lodash";
import {
  convertTimeFormat,
  formatTime,
  percentageTimeRemaining,
  replaceBaseUrl,
} from "../../../../utils/Helpers";
import {
  setEpisodedSelectLang,
  setEpisodeId,
  setEpisodeLength,
  setErrorPop,
  setErrorPopMsg,
  setVideoCount,
  setVideoPlay,
} from "../../../../store/action";
import { useSelector, useDispatch } from "react-redux";
import ModalTwo from "../../../../components/VideoModal/ModalTwo";
import VideoJS from "../../../../components/Video/VideoMedia";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import * as MS from "../../../../styles/ModelStyled";
import { colorProvider } from "../../../../utils/StylePropertiy";
import Modal from "../../../../components/Modal/Modal";
import crossIcon from "../../../../assets/images/crossIcon.png";
import ReactHlsPlayer from "react-hls-player";
import EpisodeNotPlay from "../../../../assets/images/EpisodeNotPlay.png";
import CircleLoaderTwo from "../../../../components/Loader/CircleLoaderTwo";
import ModalComplete from "../../../../components/Modal/ModalComplete";
import * as SEC from "../../../../styles/SectionStyledTwo";
import successModal from "../../../../assets/images/warns.png";
import Hls from "hls.js";
import Control from "../../../../components/Control";
import CircleLoader from "../../../../components/Loader/CircleLoader";

const CourseContent = ({
  theme,
  courseId,
  localState,
  dispatch,
  navigate,
  isChanging,
}) => {
  const playerRefs = useRef([]);
  const videoCount = useSelector((state) => state?.videoCount);
  const bannerThumb = useSelector((state) => state?.bannerThumb);
  const episodeRefresh = useSelector((state) => state?.episodeRefresh);
  const selectLang = useSelector((state) => state?.selectLang);
  const selectLangJson = useSelector((state) => state?.selectLangJson);
  const languageId = useSelector((state) => state?.languageId);
  const courseMenuData = useSelector((state) => state?.courseMenuData);
  const isActionDisabled = useSelector((state) => state?.isActionDisabled);
  const refreshRestart = useSelector((state) => state?.refreshRestart);
  const dynamicRoutes = useSelector((state) =>
    state?.dynamicRoutes ? `/${state?.dynamicRoutes}` : ""
  );
  const [isTrailer, setIsTrailer] = useState(true);
  const [isEpisode, setIsEpisode] = useState(true);
  const [isTrailerVideo, setIsTrailerVideo] = useState(true);
  const [isPopPo, setIsPopPo] = useState(false);
  const [trailerUrl, setTrailerUrl] = useState("");
  const [courseEpisodeData, setCourseEpisodeData] = useState([]);
  const videoRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [episodeDetails, setEpisodeDetails] = useState({});
  const [quizCount, setQuizCount] = useState(0);
  const [count, setCount] = useState(0);
  const [isPlay, setIsPlay] = useState(false);
  const [isTrailerPlay, setIsTrailerPlay] = useState(false);
  const [episodeLoading, setEpisodeLoading] = useState(false);
  const [isNextTab, setIsNextTab] = useState(false);
  const [isLoaderAdd, setIsLoaderAdd] = useState(false);
  const [videoURL1, setvideoURL1] = useState("");
  const [videoURL2, setvideoURL2] = useState("");
  const [currentURL, setCurrentURL] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const videoPlayerRef = useRef([]);
  const isFetchingRef = useRef(false);
  const handleClose = (e) => {
    setIsOpen(e);
  };

  const getCourseEpisodeData = async () => {
    if (isFetchingRef.current) return;

    isFetchingRef.current = true;
    setEpisodeLoading(true);
    let url = Course.getCourseEpisodeData;
    const formValues = {
      courseId: courseId,
    };
    if (languageId) {
      languageId && (formValues["languageId"] = languageId);
    }
    try {
      const { data } = await axios.post(url, formValues);
      setEpisodeLoading(false);
      if (data?.result) {
        setCourseEpisodeData(data?.result[0]);
        dispatch(setEpisodeLength(data?.result[0]?.course_episodes));
      }
    } catch (error) {
      setEpisodeLoading(false);
      console.log(error.response.data.message);
      if (error.response && error.response.status === 400) {
        dispatch(setErrorPop(true));
        dispatch(setErrorPopMsg(error?.response?.data?.message));
      }
    } finally {
      isFetchingRef.current = false;
    }
  };
  useEffect(() => {
    getCourseEpisodeData();
  }, [courseId, episodeRefresh, languageId, refreshRestart]);
  useEffect(() => {
    const totalQuizzes = get(courseEpisodeData, "course_episodes", [])?.reduce(
      (acc, val) => {
        return acc + (val.assessmentQuiz ? 1 : 0);
      },
      0
    );

    setQuizCount(totalQuizzes);
  }, [courseEpisodeData]);

  const getQuizStatus = (e, val) => {
    if (e === "allow_result") {
      return (
        <CS.EpisodeSecond themeColor={theme}>
          <CS.CompleteImageBox>
            <img src={theme ? rewardIcon : rewardLight} alt="" />
          </CS.CompleteImageBox>
          <CS.SecondInnerFirst>
            <CS.CompleteContentBox themeColor={theme}>
              <div className="row-de">
                <p className="quiz-title">{val.assessmentQuiz.title} </p>
                <p className="retake-text">
                  {val.assessmentQuiz.allowTake === -1
                    ? ""
                    : `(${val.assessmentQuiz.allowTake} ${selectLangJson.retakes})`}
                  <img src={greenCheck} alt="" />
                </p>
              </div>
              <p className="desc-text">
                {val.assessmentQuiz.QuestionCount} {selectLangJson.questions}
              </p>
            </CS.CompleteContentBox>
            <CS.ViewResult
              onClick={() => {
                navigate(`${dynamicRoutes}/learner/quiz-result`, {
                  state: {
                    _id: val?.assessmentQuiz?.user_quizzes?._id,
                    quizScreen: false,
                  },
                });
              }}
            >
              <p>{selectLangJson.view_result}</p>
            </CS.ViewResult>
          </CS.SecondInnerFirst>
        </CS.EpisodeSecond>
      );
    } else if (e === "take_quiz") {
      return (
        <CS.EpisodeSecond themeColor={theme}>
          <CS.CompleteImageBox>
            <img src={theme ? rewardIcon : rewardLight} alt="" />
          </CS.CompleteImageBox>
          <CS.SecondInnerFirst>
            <CS.CompleteContentBox themeColor={theme}>
              <div className="row-de">
                <p className="quiz-title">{val.assessmentQuiz.title} </p>
                <p className="retake-text">
                  {val.assessmentQuiz.allowTake === -1
                    ? ""
                    : `(${val.assessmentQuiz.allowTake} ${selectLangJson.retakes}})`}
                </p>
              </div>
              <p className="desc-text">
                {val.assessmentQuiz.QuestionCount} {selectLangJson.questions}
              </p>
            </CS.CompleteContentBox>
            <QS.OrangeButton
              onClick={() => {
                navigate(`${dynamicRoutes}/learner/quiz`, {
                  state: {
                    _id: val.assessmentQuiz._id,
                  },
                });
              }}
            >
              <p>{selectLangJson.take_quiz}</p>
            </QS.OrangeButton>
          </CS.SecondInnerFirst>
        </CS.EpisodeSecond>
      );
    } else if (e === "disable") {
      return (
        <CS.EpisodeSecond themeColor={theme} style={{ alignItems: "center" }}>
          <CS.CompleteImageBox>
            <img
              src={
                true ? (theme ? rewardsWatch : rewardLightsUnWatch) : rewardIcon
              }
              alt=""
            />
          </CS.CompleteImageBox>
          <CS.SecondInnerFirst>
            <CS.CompleteContentBox watchColor={true} themeColor={theme}>
              <div className="row-de">
                <p className="quiz-title">{val.assessmentQuiz.title}</p>
              </div>
              <p className="desc-text">
                {val.assessmentQuiz.QuestionCount} {selectLangJson.questions}
              </p>
            </CS.CompleteContentBox>
          </CS.SecondInnerFirst>
        </CS.EpisodeSecond>
      );
    } else if (e === "retake_quiz") {
      return (
        <CS.EpisodeSecond themeColor={theme}>
          <CS.CompleteImageBox>
            <img src={theme ? rewardIcon : rewardLight} alt="" />
          </CS.CompleteImageBox>
          <CS.SecondInnerFirst>
            <CS.CompleteContentBox themeColor={theme}>
              <div className="row-de">
                <p className="quiz-title">{val.assessmentQuiz.title} </p>
                <p className="retake-text">
                  {val.assessmentQuiz.allowTake === -1
                    ? ""
                    : `(${val.assessmentQuiz.allowTake} ${selectLangJson.retakes})`}
                </p>
                <img src={greenCheck} alt="" />
              </div>
              <p className="desc-text">
                {val.assessmentQuiz.QuestionCount} {selectLangJson.questions}
              </p>
            </CS.CompleteContentBox>
            <QS.OrangeButton
              className={isActionDisabled ? "not-allowed" : ""}
              onClick={() => {
                if (!isActionDisabled) {
                  navigate(`${dynamicRoutes}/learner/quiz`, {
                    state: {
                      _id: val.assessmentQuiz._id,
                    },
                  });
                }
              }}
            >
              <p>{selectLangJson.retake_quiz}</p>
            </QS.OrangeButton>
          </CS.SecondInnerFirst>
        </CS.EpisodeSecond>
      );
    } else {
      return "";
    }
  };

  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [trailerVideoSrc, setTrailerVideoSrc] = useState("");
  const [isOpenPolicys, setIsOpenPolicys] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [seek, setSeek] = useState(0);
  const [isDuration, setIsDuration] = useState(0);
  const [maxWatchedTime, setMaxWatchedTime] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [qualities, setQualities] = useState([]);
  const [hlsInstance, setHlsInstance] = useState(null);
  const [currentQuality, setCurrentQuality] = useState("auto");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(0);
  // const [  ]
  const hlsRef = useRef(null); // Using useRef to persist hls instance
  const controlRef = useRef(null); // Using useRef to persist hls instance

  const handleVideoClose = (e) => {
    setIsOpenVideo(e);
  };
  const skeletonBaseColor = theme ? "#1F242F" : "#EDEEF1";
  const skeletonHighlightColor = theme ? "#1F242F" : "#EDEEF1";

  const nextTab = async () => {
    setIsNextTab(true);
    let url = NextTab.nextTab;
    try {
      const { data } = await axios.post(url, {
        courseId: courseId,
        tabName: "courses-content",
        languageId: selectLang,
      });
      setIsNextTab(false);
      if (data?.data?.model?.message) {
        setIsOpenPolicys(true);
        setModalMsg(data?.data?.model?.message);
      }
      if (data?.data?.Commitee) {
        return navigate(`${dynamicRoutes}/learner/courses/committee`);
      }
      if (data?.data?.QUIZ_SCREEN) {
        return navigate(`${dynamicRoutes}/learner/courses/quiz-result`);
      }
      if (data?.data?.VIEW_POLICY_DOCUMENTS) {
        return navigate(`${dynamicRoutes}/learner/courses/policy-document`);
      }
    } catch (error) {
      console.log(error.response.data.message);
      setIsNextTab(false);
    }
  };
  const handleMetadata = (index, timeStr = "00:00:00") => {
    const parts = timeStr?.split(":");
    const hours = parseInt(parts[0], 10);
    const minutes = parts[1] ? parseInt(parts[1], 10) : 0;
    const seconds = parts[2] ? parseInt(parts[2], 10) : 0;
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;

    const player = playerRefs.current[index];
    if (player && player.current) {
      player.current.currentTime = totalSeconds || 0;
    }
  };

  useEffect(() => {
    playerRefs.current =
      courseEpisodeData?.course_episodes?.map(
        (_, index) => playerRefs.current[index] || React.createRef()
      ) || [];
  }, [courseEpisodeData]);
  let firstPlay =
    "https://s3rain.s3.ap-south-1.amazonaws.com/1721220010340_WorkFlix+Animation+Logo+.mp4";

  const getMediaIconPlay = (val, index) => {
    if (
      val?.user_episode_details?.url &&
      val?.last_time_stamp !== "00:00:00" &&
      val.last_time_stamp !== val.end_time_stamp
    ) {
      return (
        <CS.ImageBox>
          <CS.MediaPlayerCon>
            <CS.EpisodeVideoContainer>
              <ReactHlsPlayer
                className="video-class-element-two"
                playerRef={playerRefs.current[index]}
                src={val?.user_episode_details?.url}
                muted={true}
                autoPlay={false}
                volume={0.5}
                controls={false}
                onLoadedMetadata={() =>
                  setTimeout(
                    () => handleMetadata(index, val?.last_time_stamp),
                    0
                  )
                }
                width="120px"
                height="80px"
              />
            </CS.EpisodeVideoContainer>
            <img
              className="play-butttonon-buttons"
              src={episodePlay}
              alt=""
              onClick={() => {
                if (val?.user_episode_details?.url) {
                  dispatch(setEpisodeId(val?._id));
                  dispatch(setEpisodedSelectLang(languageId));
                  dispatch(setVideoPlay(true));
                  dispatch(setVideoCount(videoCount + 1));
                } else {
                  return "";
                }
              }}
            />
            <CS.ProgressContainer>
              <CS.ProgressBar
                style={{
                  width: `${percentageTimeRemaining(
                    val?.user_episode_details?.end_time_stamp,
                    val?.user_episode_details?.last_time_stamp
                  )}%`,
                }}
              ></CS.ProgressBar>
            </CS.ProgressContainer>
          </CS.MediaPlayerCon>
        </CS.ImageBox>
      );
    } else if (val?.user_episode_details?.url) {
      return (
        <CS.ImageBoxTrailer>
          <img src={val.thumbnailImage} alt="" />
          <img
            className={`play-butttonon ${
              isActionDisabled ? "not-allowed" : ""
            }`}
            src={episodePlay}
            alt=""
            onClick={() => {
              if (!isActionDisabled && val?.user_episode_details?.url) {
                dispatch(setEpisodeId(val?._id));
                dispatch(setEpisodedSelectLang(languageId));
                dispatch(setVideoPlay(true));
                dispatch(setVideoCount(videoCount + 1));
              } else {
                return "";
              }
            }}
          />
        </CS.ImageBoxTrailer>
      );
    } else {
      return (
        <CS.ImageBoxTrailer>
          <img src={val.thumbnailImage} alt="" />
          <img
            className={`play-butttonon ${
              isActionDisabled ? "not-allowed" : ""
            }`}
            src={EpisodeNotPlay}
            alt=""
            onClick={() => {
              setIsPopPo(true);
            }}
          />
        </CS.ImageBoxTrailer>
      );
    }
  };

  const shouldShowNextButton = (courseMenu) => {
    const feedbackIndex = courseMenu?.findIndex(
      (menu) => menu.key === "course_content"
    );

    if (feedbackIndex !== -1 && feedbackIndex + 1 < courseMenu?.length) {
      const nextItem = courseMenu[feedbackIndex + 1];
      if (nextItem.key === "leaderboard") {
        return false;
      }
      return true;
    }
    return false;
  };

  const showNextButton = shouldShowNextButton(courseMenuData);

  const handleNextClick = (courseMenu) => {
    const feedbackIndex = courseMenu?.findIndex(
      (menu) => menu.key === "course_content"
    );

    if (feedbackIndex !== -1 && feedbackIndex + 1 < courseMenu?.length) {
      const nextItem = courseMenu[feedbackIndex + 1];
      if (nextItem.key === "quiz_result") {
        navigate(`${dynamicRoutes}/learner/courses/quiz-result`);
      } else if (nextItem.key === "policy_documents") {
        navigate(`${dynamicRoutes}/learner/courses/policy-document`);
      } else if (nextItem.key === "commitee") {
        navigate(`${dynamicRoutes}/learner/courses/committee`);
      } else if (nextItem.key === "feedback") {
        navigate(`${dynamicRoutes}/learner/courses/feedback`);
      } else if (nextItem.key === "certificate") {
        navigate(`${dynamicRoutes}/learner/courses/certificate`);
      } else if (nextItem.key === "course_content") {
        navigate(`${dynamicRoutes}/learner/courses-content`);
      }
    }
  };

  const handleMetadatas = (e) => {
    setIsLoaderAdd(false);
    setIsDuration(formatTime(e.target.duration));
    // setIsSamDuration(e.target.duration);
    // setIsLogoAddDuration(Math.floor(e.target.duration));
    const savedVolume =
      parseFloat(localStorage.getItem("rainLearnerVolume")) || 0.5; // Default to 50% if not set
    setVolume(savedVolume);
    videoPlayerRef.current.volume = savedVolume;
  };
  const handleTimeUpdate = () => {
    if (videoPlayerRef.current) {
      const currentTime = videoPlayerRef.current.currentTime || 0;
      const duration = videoPlayerRef.current.duration;
      const seekValue = (currentTime / duration) * 100;
      setCurrentTime(currentTime);
      setSeek(seekValue); // Update the seek state
      // if (duration > 0 && !apiCalled && duration === currentTime) {
      //   setApiCalled((apiCalled) => {
      //     if (!apiCalled) {
      //       debouncedNameFunction.current(currentTime);
      //       return true;
      //     }
      //     return apiCalled;
      //   });
      // }
    }
  };
  const handleVideoEnd = () => {
    if (currentURL === videoURL1) {
      setIsLoaderAdd(true);
      setCurrentURL(videoURL2); // Switch to the second video
      if (videoPlayerRef.current) {
        var playPromise = videoPlayerRef?.current?.play();

        if (playPromise !== undefined) {
          playPromise
            .then((_) => {
              // videoPlayerRef?.current?.play();
              setIsPlaying(true);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      // setIsPaused(false); // Autoplay the next video
    } else {
      // Optionally reset to the first video or handle end of playlist
      console.log("End of playlist");
      setIsPlaying(false);
    }
  };

  // Media Control

  const handlePlay = () => {
    var playPromise = videoPlayerRef?.current?.play();

    if (playPromise !== undefined) {
      playPromise
        .then((_) => {
          // videoPlayerRef?.current?.play();
          setIsPlaying(true);
          setIsLoaderAdd(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handlePause = () => {
    videoPlayerRef?.current?.pause();
    setIsPlaying(false);
  };

  const volumeChangeHandler = (event) => {
    const newVolume = parseFloat(event.target.value) / 100;
    setVolume(newVolume);
    videoPlayerRef.current.volume = newVolume;
  };

  const toggleMute = () => {
    const newMuteStatus = !isMuted;
    setIsMuted(newMuteStatus);
    videoPlayerRef.current.muted = newMuteStatus;
  };

  const handleSeek = (event) => {
    const newSeekValue = parseInt(event.target.value, 10); // Get the percentage of duration from the slider
    const newSeekTime = (newSeekValue / 100) * videoPlayerRef.current.duration; // Convert percentage to seconds

    videoPlayerRef.current.currentTime = newSeekTime;
    setSeek(newSeekValue); // Update the slider position

    setIsDuration(formatTime(videoPlayerRef.current.duration)); // Optional: If you need to display the duration
  };

  const handleQualityChange = (levelIndex) => {
    if (hlsInstance) {
      const currentTime = videoPlayerRef.current.currentTime || 0;
      const isPaused = videoPlayerRef.current.paused;
      hlsInstance.currentLevel = levelIndex;
      hlsInstance.startLoad();
      hlsInstance.once(Hls.Events.FRAG_LOADED, () => {
        videoPlayerRef.current.currentTime = currentTime;
        if (!isPaused) {
          videoPlayerRef?.current?.play();
        }
      });
      setCurrentQuality(levelIndex);
    }
  };

  const toggleFullScreen = () => {
    const videoElement = controlRef.current.closest(".media-class-box"); // Reference to your video player

    if (!document.fullscreenElement) {
      if (videoElement.requestFullscreen) {
        setIsFullScreen(true);
        videoElement.requestFullscreen(); // Standard way to request fullscreen
      } else if (videoElement.webkitRequestFullscreen) {
        setIsFullScreen(true);
        videoElement.webkitRequestFullscreen(); // Safari
      } else if (videoElement.msRequestFullscreen) {
        setIsFullScreen(true);
        videoElement.msRequestFullscreen(); // IE11
      }
    } else {
      if (document.exitFullscreen) {
        setIsFullScreen(false);
        document.exitFullscreen(); // Exit fullscreen
      } else if (document.webkitExitFullscreen) {
        setIsFullScreen(false);
        document.webkitExitFullscreen(); // Safari
      } else if (document.msExitFullscreen) {
        setIsFullScreen(false);
        document.msExitFullscreen(); // IE11
      }
    }
  };

  

  return (
    <>
      <CS.InnerFirstTwo themeColor={theme}>
        <CS.CourseTitleRow
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <CS.ComTitle themeColor={theme}>
            <p>{selectLangJson.trailers}</p>
            <span>
              ({get(courseEpisodeData, "trailers", [])?.length}{" "}
              {selectLangJson?.trailers})
            </span>
          </CS.ComTitle>
          <CS.ComTitle
            onClick={() => {
              
              setIsTrailer(!isTrailer);
            }}
          >
            <img
              src={
                isTrailer
                  ? theme
                    ? darkTitleTop
                    : lightTitleTop
                  : theme
                  ? darkTitleBottom
                  : lightTitleBottom
              }
              alt=""
            />
          </CS.ComTitle>
        </CS.CourseTitleRow>
        {isTrailer ? (
          <CS.EpisodeList themeColor={theme}>
            {episodeLoading ? (
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <Skeleton
                    width={20}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={20}
                    // style={{ borderRadius: "12px" }}
                  />
                  <Skeleton
                    width={130}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={80}
                    style={{ borderRadius: "12px" }}
                  />
                  <div>
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                    <Skeleton
                      width={300}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px", marginTop: "1rem" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: "1",
                      justifyContent: "right",
                    }}
                  >
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                  }}
                >
                  <Skeleton
                    width={20}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={20}
                    // style={{ borderRadius: "12px" }}
                  />
                  <Skeleton
                    width={130}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={80}
                    style={{ borderRadius: "12px" }}
                  />
                  <div>
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                    <Skeleton
                      width={300}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px", marginTop: "1rem" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: "1",
                      justifyContent: "right",
                    }}
                  >
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              get(courseEpisodeData, "trailers", [])?.map((val, ind) => {
                return (
                  <CS.EpisodesCard
                    key={ind}
                    themeColor={theme}
                    style={{ margin: 0 }}
                  >
                    <CS.EpisodeContent>
                      <CS.EpisodeFirst>
                        <CS.EpisodeImageBox>
                          <CS.SerialNumber themeColor={theme}>
                            {/* <p>{`${selectLangJson[`number_${ind+1}`]}`}</p> */}
                            <p>{ind + 1}</p>
                          </CS.SerialNumber>
                          <CS.ImageBoxTrailer>
                            <img
                              src={get(bannerThumb, "thumbUrl", "")}
                              alt=""
                            />
                            <img
                              className="play-butttonon"
                              src={episodePlay}
                              onClick={() => {
                                setIsOpenVideo(true);
                                setIsFullScreen(false);
                                setvideoURL1(val?.logo);
                                setCurrentURL(val?.logo);
                                setvideoURL2(val?.convert_url);
                                
                              }}
                              alt=""
                            />
                          </CS.ImageBoxTrailer>
                        </CS.EpisodeImageBox>
                        <CS.EpisodeContentBox>
                          <CS.EpisodeTitleRow>
                            <CS.EpisodeTitle themeColor={theme}>
                              <p>{val.title}</p>
                            </CS.EpisodeTitle>
                            <CS.EpisodeTime themeColor={theme}>
                              <img src={greyClock} alt="" />
                              <p>
                                {convertTimeFormat(
                                  get(val, "videoTime", "00:00:00"),
                                  selectLangJson.min,
                                  selectLangJson?.second
                                )}
                              </p>
                            </CS.EpisodeTime>
                          </CS.EpisodeTitleRow>
                          <MoreLessEpisode
                            desc={val.description}
                            theme={theme}
                          />
                        </CS.EpisodeContentBox>
                      </CS.EpisodeFirst>
                    </CS.EpisodeContent>
                  </CS.EpisodesCard>
                );
              })
            )}
          </CS.EpisodeList>
        ) : (
          ""
        )}
      </CS.InnerFirstTwo>
      <CS.InnerFirstTwo themeColor={theme}>
        <CS.CourseTitleRow
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <CS.ComTitle themeColor={theme}>
            <p>{selectLangJson.episodes_and_quizzes}</p>
            <span>
              ({get(courseEpisodeData, "course_episodes", [])?.length}{" "}
              {selectLangJson.episodes}, {quizCount} {selectLangJson.quizzes})
            </span>
          </CS.ComTitle>
          <CS.ComTitle
            onClick={() => {
              setIsEpisode(!isEpisode);
            }}
          >
            <img
              src={
                isEpisode
                  ? theme
                    ? darkTitleTop
                    : lightTitleTop
                  : theme
                  ? darkTitleBottom
                  : lightTitleBottom
              }
              alt=""
            />
          </CS.ComTitle>
        </CS.CourseTitleRow>
        {isEpisode ? (
          <CS.EpisodeList themeColor={theme}>
            {episodeLoading ? (
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <Skeleton
                    width={20}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={20}
                    // style={{ borderRadius: "12px" }}
                  />
                  <Skeleton
                    width={130}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={80}
                    style={{ borderRadius: "12px" }}
                  />
                  <div>
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                    <Skeleton
                      width={300}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px", marginTop: "1rem" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: "1",
                      justifyContent: "right",
                    }}
                  >
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <Skeleton
                    width={20}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={20}
                    // style={{ borderRadius: "12px" }}
                  />
                  <Skeleton
                    width={130}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={80}
                    style={{ borderRadius: "12px" }}
                  />
                  <div>
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                    <Skeleton
                      width={300}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px", marginTop: "1rem" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: "1",
                      justifyContent: "right",
                    }}
                  >
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <Skeleton
                    width={20}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={20}
                    // style={{ borderRadius: "12px" }}
                  />
                  <Skeleton
                    width={130}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={80}
                    style={{ borderRadius: "12px" }}
                  />
                  <div>
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                    <Skeleton
                      width={300}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px", marginTop: "1rem" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: "1",
                      justifyContent: "right",
                    }}
                  >
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    marginBottom: "2rem",
                  }}
                >
                  <Skeleton
                    width={20}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={20}
                    // style={{ borderRadius: "12px" }}
                  />
                  <Skeleton
                    width={130}
                    baseColor={skeletonBaseColor}
                    highlightColor={skeletonHighlightColor}
                    height={80}
                    style={{ borderRadius: "12px" }}
                  />
                  <div>
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                    <Skeleton
                      width={300}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px", marginTop: "1rem" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: "1",
                      justifyContent: "right",
                    }}
                  >
                    <Skeleton
                      width={130}
                      baseColor={skeletonBaseColor}
                      highlightColor={skeletonHighlightColor}
                      height={30}
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              get(courseEpisodeData, "course_episodes", [])?.map(
                (val, index) => {
                  return (
                    <CS.EpisodesCard
                      key={index}
                      themeColor={theme}
                      style={{ margin: 0 }}
                    >
                      <CS.EpisodeContent>
                        <CS.EpisodeFirst>
                          <CS.EpisodeImageBox>
                            <CS.SerialNumber themeColor={theme}>
                              <p>{index + 1}</p>
                            </CS.SerialNumber>
                            {getMediaIconPlay(val, index)}
                          </CS.EpisodeImageBox>
                          <CS.EpisodeContentBox>
                            <CS.EpisodeTitleRow>
                              <CS.EpisodeTitle themeColor={theme}>
                                <p>{val.episodeName}</p>
                                {val.episode_completed ? (
                                  <img src={greenCheck} alt="" />
                                ) : (
                                  ""
                                )}
                              </CS.EpisodeTitle>
                              <CS.EpisodeTime themeColor={theme}>
                                <img src={greyClock} alt="" />
                                <p>
                                  {convertTimeFormat(
                                    val.videoTime,
                                    selectLangJson.min,
                                    selectLangJson?.second
                                  )}
                                </p>
                              </CS.EpisodeTime>
                            </CS.EpisodeTitleRow>
                            <MoreLessEpisode
                              desc={val.description}
                              selectLangJson={selectLangJson}
                            />
                          </CS.EpisodeContentBox>
                        </CS.EpisodeFirst>
                        {/* {val.assessmentQuiz ? (
                                val.quizStatus === "disable" ? (
                                  <CS.EpisodeSecond
                                    themeColor={theme}
                                    style={{ alignItems: "center" }}
                                  >
                                    <CS.CompleteImageBox>
                                      <img
                                        src={
                                          true
                                            ? theme
                                              ? rewardsWatch
                                              : rewardLightsUnWatch
                                            : rewardIcon
                                        }
                                        alt=""
                                      />
                                    </CS.CompleteImageBox>
                                    <CS.SecondInnerFirst>
                                      <CS.CompleteContentBox
                                        watchColor={true}
                                        themeColor={theme}
                                      >
                                        <div className="row-de">
                                          <p className="quiz-title">
                                            {val.assessmentQuiz.title}{" "}
                                          </p>
                                        </div>
                                        <p className="desc-text">
                                          {val.assessmentQuiz.QuestionCount}{" "}
                                          Questions
                                        </p>
                                      </CS.CompleteContentBox>
                                    </CS.SecondInnerFirst>
                                  </CS.EpisodeSecond>
                                ) : (
                                  <CS.EpisodeSecond themeColor={theme}>
                                    <CS.CompleteImageBox>
                                      <img
                                        src={theme ? rewardIcon : rewardLight}
                                        alt=""
                                      />
                                    </CS.CompleteImageBox>
                                    <CS.SecondInnerFirst>
                                      <CS.CompleteContentBox themeColor={theme}>
                                        <div className="row-de">
                                          <p className="quiz-title">
                                            {val.assessmentQuiz.title}{" "}
                                          </p>
                                          <p className="retake-text">
                                            {" "}
                                            (2 Retakes)
                                          </p>
                                          <img src={greenCheck} alt="" />
                                        </div>
                                        <p className="desc-text">
                                          {val.assessmentQuiz.QuestionCount}{" "}
                                          Questions
                                        </p>
                                      </CS.CompleteContentBox>
                                      <CS.ViewResult
                                        onClick={() => {
                                          navigate("/quiz", {
                                            state: {
                                              _id: val.assessmentQuiz._id,
                                            },
                                          });
                                        }}
                                      >
                                        <p>Take Quiz</p>
                                      </CS.ViewResult>
                                    </CS.SecondInnerFirst>
                                  </CS.EpisodeSecond>
                                )
                              ) : (
                                ""
                              )} */}
                        {val.assessmentQuiz
                          ? getQuizStatus(val.quizStatus, val)
                          : ""}
                      </CS.EpisodeContent>
                    </CS.EpisodesCard>
                  );
                }
              )
            )}
          </CS.EpisodeList>
        ) : (
          ""
        )}
        {console.log(currentURL)}
        {console.log(replaceBaseUrl(currentURL, "https://cdn.rainmaker.co.in"))}
        <ModalTwo
          isOpen={isOpenVideo}
          isClose={handleVideoClose}
          handleTrailerPlay={setIsTrailerPlay}
          theme={theme}
          component={
            <SS.VideoContainerSo
              isFullScreen={isFullScreen}
              className="media-class-box"
              themeColor={theme}
            >
              {/* {isTrailerPlay ? ( */}
              <SS.MediaContainer>
                {isLoaderAdd ? <CircleLoader themeColor={theme} /> : ""}
                <ReactHlsPlayer
                  className="video-class-element"
                  style={{
                    display: isLoaderAdd ? "none" : "flex",
                  }}
                  // ref={(el) => setVideoRef(el, index)}
                  playerRef={videoPlayerRef}
                  src={currentURL}
                  // src={replaceBaseUrl(
                  //   currentURL,
                  //   "https://cdn.rainmaker.co.in"
                  // )}
                  muted={isMuted}
                  autoPlay={true}
                  volume={volume}
                  onLoadedMetadata={handleMetadatas}
                  onEnded={handleVideoEnd}
                  onTimeUpdate={handleTimeUpdate}
                  width={isFullScreen ? "100%" : 800}
                  height={isFullScreen ? "100%" : 450}
                  controls={false}
                />
                {currentURL !== videoURL1 ? (
                  <Control
                    onPlay={handlePlay}
                    onPause={handlePause}
                    playing={isPlaying}
                    onVolumeChange={volumeChangeHandler}
                    volume={volume * 100}
                    handleMute={toggleMute}
                    isMuted={isMuted}
                    seek={seek}
                    handleSeekChange={handleSeek}
                    duration={isDuration}
                    currentTime={formatTime(currentTime)}
                    qualities={qualities}
                    handleQualityChange={handleQualityChange}
                    currentQuality={currentQuality}
                    toggleFullScreen={toggleFullScreen}
                    controlRef={controlRef}
                    isFullScreen={isFullScreen}
                  />
                ) : (
                  ""
                )}
              </SS.MediaContainer>
            </SS.VideoContainerSo>
          }
        />
        <QS.ButtonGroup themeColor={theme}>
          {/* <QS.CancelButton
            themeColor={theme}
            onClick={() => {
              navigate("/courses/policy-document");
            }}
          >
            {selectLangJson.skip_for_now}
          </QS.CancelButton> */}
          {showNextButton && (
            <QS.SaveButton
              cursor={isNextTab}
              disabled={isNextTab}
              className="buttonload"
              onClick={() => {
                handleNextClick(courseMenuData);
                // nextTab();
              }}
              style={{ padding: "0.6rem 3rem" }}
            >
              {isNextTab ? (
                <i class="fa fa-spinner fa-spin"></i>
              ) : (
                selectLangJson.next
              )}
            </QS.SaveButton>
          )}
        </QS.ButtonGroup>
      </CS.InnerFirstTwo>
      <Modal
        maxWidth={"400px"}
        isOpen={isOpenPolicys}
        // isClose={handleClose}
        backColor={colorProvider.darkBlue}
        component={
          <MS.LeaderContainer themeColor={theme}>
            <MS.LeaderHeader
              style={{ border: "none", justifyContent: "end" }}
              themeColor={theme}
            >
              <MS.CrossButton
                onClick={() => {
                  setIsOpenPolicys(false);
                }}
              >
                <img src={crossIcon} alt="" />
              </MS.CrossButton>
            </MS.LeaderHeader>
            <MS.HeaderBox themeColor={theme}>
              <p className="head-title">{modalMsg}</p>
            </MS.HeaderBox>
          </MS.LeaderContainer>
        }
      />
      <ModalComplete
        isOpen={isPopPo}
        maxWidth="500px"
        theme={theme}
        component={
          <SEC.InnerSectionSuccessSoEpCom
            themeColor={theme}
            style={{ padding: "1rem 0" }}
          >
            <SEC.SuccessIconBoxSo>
              <img src={theme ? successModal : successModal} alt="danger" />
            </SEC.SuccessIconBoxSo>
            <SEC.TitleSo themeColor={theme}>
              {selectLangJson?.warning}
            </SEC.TitleSo>
            <SEC.Subtitle themeColor={theme}>
              {selectLangJson?.episode_disable}
            </SEC.Subtitle>
            <QS.ButtonGroup style={{ width: "100%" }} themeColor={theme}>
              <QS.CancelButton
                style={{ width: "100%", padding: "1rem", fontSize: "1rem" }}
                themeColor={theme}
                onClick={() => {
                  setIsPopPo(false);
                }}
              >
                {selectLangJson?.cancel}
              </QS.CancelButton>
            </QS.ButtonGroup>
          </SEC.InnerSectionSuccessSoEpCom>
        }
      />
    </>
  );
};

export default CourseContent;
